const refundRejectionStatusInfractionAPI = require('../infraction/refundRejectionStatus');

const refundRejectionStatus = {
  noBalance: 0,
  accountClosure: 1,
  other: 3,
  convertToJDPI(status) {
    switch (status) {
      case refundRejectionStatusInfractionAPI.NO_BALANCE:
        return this.noBalance;
      case refundRejectionStatusInfractionAPI.ACCOUNT_CLOSURE:
        return this.accountClosure;
      case refundRejectionStatusInfractionAPI.OTHER:
        return this.other;
      default:
        throw new Error('Invalid refund rejection status to convert to JDPI');
    }
  },
  convertFromJDPI(status) {
    switch (status) {
      case this.noBalance:
        return refundRejectionStatusInfractionAPI.NO_BALANCE;
      case this.accountClosure:
        return refundRejectionStatusInfractionAPI.ACCOUNT_CLOSURE;
      case this.other:
        return refundRejectionStatusInfractionAPI.OTHER;
      default:
        throw new Error('Invalid refund rejection status to convert from JDPI');
    }
  }
};

module.exports = refundRejectionStatus;
